import React from 'react'
import { AuditRecord } from '@trustero/trustero-api-web/lib/audit/audit_pb'
import { useModalState } from 'src/Modal/ModalStateContext'
import { ModalFormId } from 'src/components/ModalForms'
import { CAPABILITY } from '@trustero/trustero-api-web/lib/authz/permissions_pb'
import {
  StandardButton,
  StandardButtonSize,
  StandardButtonVariant,
} from 'src/components/Reusable/Buttons'
import { useCanPerformAction } from 'src/app/AppAuth/AppAuth.hooks'
import { AuditBotModal } from '../modals/AuditBotModal'
import { CheckWithEroButtonContainer } from './CheckWithEroButton.styles'

export const CheckWithEroButton = ({
  controlId,
  isDisabled = false,
  customText,
  variant = StandardButtonVariant.PRIMARY,
}: {
  controlId: string
  currentAudit?: AuditRecord
  isDisabled?: boolean
  /** Replaces the label only. Callers that also want a different weight pass `variant`. */
  customText?: string | JSX.Element
  variant?: StandardButtonVariant
}): JSX.Element => {
  const canStartAuditRun = useCanPerformAction(CAPABILITY.CAN_START_AUDIT_SCANS)
  const { openModal } = useModalState()

  const startAuditScan = async () => {
    openModal(ModalFormId.RUN_AUDITBOT)
  }

  const isButtonDisabled = !canStartAuditRun || isDisabled

  return (
    <>
      <StandardButton
        type="button"
        variant={variant}
        buttonSize={StandardButtonSize.SMALL}
        onClick={startAuditScan}
        disabled={isButtonDisabled}
      >
        <CheckWithEroButtonContainer>
          {customText || 'Test Control'}
        </CheckWithEroButtonContainer>
      </StandardButton>
      <AuditBotModal controlId={controlId} />
    </>
  )
}
